module.exports = __webpack_public_path__ + "static/media/ALARM.2484adda.svg";